import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue'

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue';

Vue.use(BootstrapVue);

import App from './App';
import { router } from './router';
import { store } from './store';

Vue.config.productionTip = false;


new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app');
